import { z } from "zod";
import { BaseEvent } from "./base";
export const DashboardClickhouseQuery_Start = BaseEvent.extend({
    name: z.literal("events.superwall.com.ops.v1.DashboardClickhouseQuery_Start"),
    event: z.object({
        application_id: z.number().optional(),
        organization_id: z.number().optional(),
        query_id: z.string(),
        query_body: z.string()
    })
});
export const DashboardClickhouseQuery_Complete = BaseEvent.extend({
    name: z.literal("events.superwall.com.ops.v1.DashboardClickhouseQuery_Complete"),
    event: z.object({
        application_id: z.number().optional(),
        organization_id: z.number().optional(),
        query_id: z.string(),
        query_body: z.string(),
        query_duration: z.number(),
        status: z.enum([
            "ok",
            "failure"
        ]),
        error: z.string().optional()
    })
});
